<template>
	<div class="by-location">
		<div
			ref="byLocation"
			style="width: 100%; height: 100%; overflow: hidden"
		></div>
	</div>
</template>

<script>
const eCharts = require("echarts");

export default {
	name: "byLocation",
	props: {
		TotalByLocationData: Array,
		showGraphByLocation: Boolean,
		viewType: String,
		showGraphByLocationexpanded: Boolean,
		showScore: Boolean,
		showCompletion: Boolean,
	},
	data() {
		return {
			performanceGraphInstance: null,
			option: {
				dataZoom: [
					{
						show: false,
						startValue: 0,
						endValue: 8,
						height: 20,
						zoomLock: true,
						zoomOnMouseWheel: false,
						moveOnMouseMove: false,
						moveOnMouseWheel: true,
						preventDefaultMouseMove: true,
					},
					{
						height: 15,
						type: "slider",
						startValue: 0,
						endValue: 100,
						zoomLock: true,
						labelFormatter: "",
						moveOnMouseWheel: true,
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: "empty",
						width: 30,
						height: "100%",
						showDataShadow: false,
						zoomLock: true,
						left: "93%",
					},
				],
				color: ["#004C4C"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					formatter: (p) => {
						return `${this.getDataByRegion(p[0].axisValue)}`;
					},
				},
				grid: {
					right: "10%",
					containLabel: true,
					borderColor: "#000000", // Set the color of the gridlines
				},
				legend: {
					data: [],
					textStyle: {
						fontSize: "13",
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						axisLabel: {
							interval: 0,
							rotate: 37, //If the label names are too long you can manage this by rotating the label.
							overflow: "truncate",
							margin: 8,
							hideOverlap: true,
							align: "right",
							verticalAlign: "top",
							lineHeight: 6,
							formatter: (value) => {
								if (value.includes("__")) {
									let labelArr = value.split("__");
									return `${this.excerptText(this.titleCase(labelArr[0]), 15)}\n
						${this.excerptText(this.titleCase(labelArr[1]), 15)}`;
								} else {
									return this.excerptText(value, 15);
								}
							},
						},
						boundaryGap: true,
						data: [],
						textStyle: {
							fontSize: "14",
						},
					},
				],
				yAxis: [
					{
						min: 0,
						max: 100,
						type: "value",
						name: "",
						position: "left",
						alignTicks: false,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value}%",
						},
					},
				],
				series: [
					{
						label: {
							normal: {
								show: true,
								position: "top",
								fontSize: 9,
								color: "#000000", // Set the color of the label text
								formatter: "{c}%", // Display the value of the data point
							},
						},
						name: "",
						barGap: "10%",
						barCategoryGap: "10%",
						type: "bar",
						groupPadding: 10,
						yAxisIndex: 0,
						barWidth: "24%",
						data: [5, 7, 3, 8, 6, 4],
						showBackground: false,
						itemStyle: {
							normal: {
								barBorderRadius: [0, 0, 0, 0],
							},
						},
					},
				],
			},
		};
	},
	watch: {
		showGraphByLocation(val) {
			if (val) {
				this.initGraph();
			}
		},
		showGraphByLocationexpanded(val) {
			if (val) {
				this.initGraph();
			}
		},
	},
	methods: {
		excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
		capitalizeFirstLetter(word) {
			return word.charAt(0).toUpperCase() + word.slice(1);
		},
		initGraph() {
			if (this.viewType === "2") {
				// Use Vue's set method to ensure reactivity
				this.$set(this.option, "dataZoom", [
					{
						show: false,
						startValue: 0,
						endValue: 4,
						height: 20,
						zoomLock: true,
						zoomOnMouseWheel: false,
						moveOnMouseMove: false,
						moveOnMouseWheel: true,
						preventDefaultMouseMove: true,
					},
					{
						height: 15,
						type: "slider",
						startValue: 0,
						endValue: 100,
						zoomLock: true,
						labelFormatter: "",
						moveOnMouseWheel: true,
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: "empty",
						width: 30,
						height: "100%",
						showDataShadow: false,
						zoomLock: true,
						left: "93%",
					},
				]);
			}

			let labelsData = [...this.TotalByLocationData].map(
				(el) =>
					el.name
						.split(" ") // Split the name into words
						.map((word) => this.capitalizeFirstLetter(word)) // Capitalize each word
						.join(" ") // Join the words back together
			);

			let total = [];
			if (this.showScore) {
				total = [...this.TotalByLocationData].map(
					(el) => el["completed_score_%"]
				);
			} else {
				total = [...this.TotalByLocationData].map((el) => el["completion_%"]);
			}
			this.option.xAxis[0].data = labelsData;
			this.option.series[0].data = total;
			const chartContainer = this.$refs.byLocation;
			this.performanceGraphInstance = eCharts.init(chartContainer);
			this.performanceGraphInstance.setOption(this.option);
			if (this.viewType == "1") {
				this.$emit("emitshowGraphByLocation");
			} else {
				this.$emit("emitshowGraphByLocationexpanded");
			}
			this.$forceUpdate();
		},
		getDataByRegion(region) {
			let content = "";
			let labelTooltip = "";
			const data = this.TotalByLocationData.find(
				(el) => el.name.toLowerCase() === region.toLowerCase()
			);
			const totalValue = data
				? this.showScore
					? data["completed_score_%"]
					: this.showCompletion
					? data["completion_%"]
					: "N/A"
				: "N/A";
			labelTooltip = this.showScore
				? "Completion Score %"
				: this.showCompletion
				? "Completed %"
				: "";
			content = `<div style="display: flex; flex-direction: column; gap: 5px; padding: 5px;">
			<div style="style="display: flex; justify-content: center;">
			    <div style="text-transform: capitalize; text-align: center; text-decoration: underline;">${data.name}</div>
			</div>
			<div style="display: flex; flex-direction: row; justify-content: space-between;">
			    <div style="text-align: left;">
			        <span style="margin-right:20px">${labelTooltip} :</span>
			    </div>
			    <div style="text-align: right;">
			        <span>${totalValue}%</span>
			    </div>
			</div>
			`;
			// 		const data = this.TotalByLocationData.find(
			// 			(el) => el.name.toLowerCase() === region.toLowerCase()
			// 		);

			// 		const totalValue = data ? data["completed_score_%"] : "N/A";
			// 		content = `<div style="display: flex; flex-direction: column; gap: 5px; padding: 5px;">
			// <div style="style="display: flex; justify-content: center;">
			//     <div style="text-transform: capitalize; text-align: center; text-decoration: underline;">${data.name}</div>
			// </div>
			// <div style="display: flex; flex-direction: row; justify-content: space-between;">
			//     <div style="text-align: left;">
			//         <span style="margin-right:20px">Completion Score % :</span>
			//     </div>
			//     <div style="text-align: right;">
			//         <span>${totalValue}%</span>
			//     </div>
			// </div>
			// `;
			// 	<div style="display: flex; flex-direction: row; justify-content: space-between;">
			//         <div style="text-align: left;">
			//             <span style="margin-right:20px">Another Completion Score % :</span>
			//         </div>
			//         <div style="text-align: right;">
			//             <span>${totalValue}%</span>
			//         </div>
			//     </div>
			// </div>
			return content;
		},
	},
};
</script>

<style>
.by-location {
	height: 300px;
	width: 115% !important;
	margin-left: -80px !important;
}
.by-location > div {
	background: #ffffff;
	position: relative;
	height: 100%;
	overflow: hidden;
}
</style>
